module.exports = __webpack_public_path__ + "img/Finance 2.247616e5.svg";